export default __webpack_public_path__ + "static/media/landin-blockimg6.09ae326a.png";